import React from 'react';
import * as R from 'ramda';
import uniqid from 'uniqid';
import { connect } from 'react-redux';
import { Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import toolPaneHOC from '../toolPaneHOC';
import ConnectionToolEditor from './ConnectionToolEditor';
import ConnectionList from './ConnectionList';
import { deleteConnection, saveConnection, createConnection } from '../../common/reducers/connectionReducer';
import '../Toolbox.less';
import Tool from '../../components/Tool';


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const mapStateToProps = (state) => {
  return {
    connections: R.pathOr([], ['connection', '/connections', 'ids'], state)
      .map(id => state.connection.byId[id])
      .sort((a, b) => a.name.localeCompare(b.name)),
    activeId: R.path(['connection', '/window', 'ids', '0'], state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSave: connection => dispatch(saveConnection('/connections', connection)),
    onCreate: connection => dispatch(createConnection('/connections', connection)),
    onDelete: id => dispatch(deleteConnection('/connections', id)),
    onSelect: id => dispatch({ type: 'SELECT_CONNECTION', payload: { keyWindow: '/window', id } }),
  };
};

class Index extends React.Component {
  state = {
    view: 'list',
  };

  goToAdd = () => {
    this.setState({ view: 'add' });
  };

  goToList = () => {
    this.setState({ view: 'list' });
  };

  createNewConnection = (props) => {
    const { onCreate, connections } = this.props;
    onCreate({
      ...props,
    });

    this.goToList();
  };

  saveConnection = (props) => {
    const { onSave, connections } = this.props;
    const { view } = this.state;
    const editConnection = connections.find(connection => connection.id === view);
    onSave(
      {
        ...editConnection,
        ...props,
      },
    );

    this.goToList();
  };

  deleteConnection = () => {
    const { onDelete } = this.props;
    const { view } = this.state;
    onDelete(parseInt(view, 10));

    this.goToList();
  };

  selectConnection = (id) => {
    const { onSelect } = this.props;
    onSelect(id);
  };

  editConnection = (id) => {
    this.setState({ view: id });
  };

  render() {
    const { connections, activeId } = this.props;
    const { view } = this.state;
    const editConnection = connections.find(connection => connection.id === view);
    return (
      <Tool
        title="Connections"
        subTitle="My Connections"
        actions={[
          <Tool.Header.Action
            icon="plus"
            onClick={this.goToAdd}
          />,
        ]}
        subRoute={view !== 'list' && (
          <ConnectionToolEditor
            connection={editConnection}
            onDelete={this.deleteConnection}
            onBack={this.goToList}
            onSubmit={editConnection ? this.saveConnection : this.createNewConnection}
          />
        )}
      >
        <ConnectionList
          onEdit={this.editConnection}
          onSelect={this.selectConnection}
          connections={connections}
          activeId={activeId}
        />
      </Tool>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
